import {
    Component,
    ElementRef,
    Input,
    OnInit,
    Renderer2,
    ViewEncapsulation,
    Output,
    EventEmitter,
} from '@angular/core';
import { TemplateLayoutHelper } from '@fi-app/template/template-layout-helper';

@Component({
    selector: 'fi-document-edit-item',
    templateUrl: './edit-item.component.html',
    styleUrls: ['./edit-item.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class DocumentEditItemComponent implements OnInit {
    @Input() mouseClickEvent: MouseEvent;
    @Input() item;
    @Input() selectedColumn;
    @Input() languageId: number;
    @Input() templateLayoutHelper: TemplateLayoutHelper;
    @Output('close') closeEmitter: EventEmitter<any> = new EventEmitter();
    @Output('mediaBankFileChanged') mediaBankFileChangedEmitter: EventEmitter<any> = new EventEmitter();
    @Output() contentChange = new EventEmitter();

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
    ) {}

    ngOnInit() {
        this.renderer.addClass(this.elementRef.nativeElement, 'column-' + this.selectedColumn);
    }

    onClose($event) {
        this.closeEmitter.emit($event);
    }

    onMediaBankFileChanged($event) {
        this.mediaBankFileChangedEmitter.emit($event);
    }

    onContentChange($event) {
        this.contentChange.emit($event);
    }
}
